import script from "./CategorySidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./CategorySidebar.vue?vue&type=script&setup=true&lang=js"

import "./CategorySidebar.vue?vue&type=style&index=0&id=b4e75274&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4e75274"]])

export default __exports__